// extracted by mini-css-extract-plugin
module.exports = {"infoBoxPrepaid":"InfoBoxPrepaid-Jtails_infoBoxPrepaid_1wecR","ordersList":"InfoBoxPrepaid-Jtails_ordersList_366Fd"};